import { Box, IconButton, Tooltip, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { getImagePreview } from '../shared/constants'
import { verifyExtension } from '../shared/constants'

import { handleMultipleFiles } from '../utils/uploadImage'
import ImageDialog from './Dialog/ImageDialog'
import PdfDialog from './Dialog/PdfDialog'
import { AiFillInfoCircle, AiOutlineArrowRight } from 'react-icons/ai'
import CustomDialog from './CustomDialog'
import { toastMessage } from '../shared/AlertPopup'
import { convertKb } from '../utils/otherHelper'
export default function ImageInputField({ label, setForm, form, name, multiple, limit = 7000, onChange = false, fullWidth, value, accept = 'image/*', restriction = [], s3upload= false, noOfFiles= 10}) {
  const [src, setSrc] = useState([])
  const [openRes, setOpenRes] = useState(false)
  const [open, setOpen] = useState(false)
  const [imagePreview, setImagePreview] = useState(false)
  const [loading, setLoading] = useState(false)
  //console.log('VALUE : ', value)
  // useEffect(() => {
  //   // if (onChange) {
  //   //   setSrc(getImagePreview(value))
  //   // } else {
  //   if (!onChange) {
  //     setSrc(getImagePreview(form[name]))
  //   }
  //   // }
  // }, [form[name]])

  useEffect(() => {
    if (onChange) {
      setSrc(getImagePreview(value))
    } else {
      if (form[name]) {
        setSrc(getImagePreview(form[name]))
      }
    }
  }, [form, name, onChange, value])

  console.log('SRC : ', src)
  const getExtension = (url) => {
    console.log({ url })
    try {
      if (url.length > 0) {
        let ext = new URL(url[0])
        let filename = ext.pathname.split('/').reverse()[0]
        return filename.split('.')[2]
      }
    } catch (error) {
      return null
    }
  }
  console.log({ limit })
  const handleFileChange = (e) => {
    const nFiles = e.target.files.length
    // console.log('SIZE : ', e.target.files[0].size)
    const temp = convertKb(e.target.files[0].size)
    console.log(temp)

    console.log('NFiles : ', nFiles)
    if (convertKb(e.target.files[0].size) > limit) {
      return toastMessage(`File Cannot Be Greater Than  ${limit} MB`, 'error')
    }else if(nFiles > noOfFiles){
      return toastMessage(`File Limit it 3`, 'error')
    } else {
      if(s3upload){
        handleMultipleFiles(e, setLoading, form, setForm);
        console.log(`files uploaded`, 'success')
      }else
      setForm({ ...form, [name]: e.target.files })
    }
  }

  const extension = getExtension(src)
  // console.log('extension : ', extension)

  const Restrictions = restriction.length > 0 ? restriction : ['File Should not be greater than 5 mb']
  return (
    <Box display="flex" justifyContent="space-between" flexDirection="column" style={{ marginTop: '27px' }}>
      <Box display="flex">
        <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{label}</Typography>
        {/* {limit && <Typography style={{ fontSize: '10px', color: 'red', marginTop: '3px', marginLeft: '5px', fontWeight: 'bold' }}>( Max Size : 200KB) </Typography>} */}
        {/* <IconButton > */}
        <AiFillInfoCircle style={{ color: 'grey', fontSize: '17px', marginLeft: '5px', cursor: 'pointer' }} onClick={() => setOpenRes(true)} />

        <CustomDialog open={openRes} handleClose={() => setOpenRes(false)} heading="File Upload Restrictions">
          {Restrictions &&
            Restrictions.map((val) => (
              <Typography style={{ fontSize: '20px', fontWeight: '500', marginBottom: Restrictions.length > 1 ? '20px' : '0px' }}>
                <AiOutlineArrowRight /> {val}
              </Typography>
            ))}
        </CustomDialog>
        {/* </IconButton> */}
      </Box>
      <input
        type="file"
        onChange={onChange ? onChange : (e) => handleFileChange(e)}
        multiple={multiple ? true : false}
        name={name}
        style={{ width: fullWidth ? '100%' : '85%', borderBottom: '1px solid rgba(0, 0, 0, 0.42)' }}
        accept={accept}
      />
      <Box display="flex" marginTop="20px">
        {/* {src && extension === 'pdf'
          ? src.map((item) => <embed src={item} />)
          : src.map((item) => (
              <img
                src={item}
                width="150px"
                style={{ marginTop: '10px', cursor: 'pointer', marginLeft: '5px' }}
                onClick={() => {
                  setOpen(true)
                  setImagePreview(item)
                }}
                alt="pre"
              />
              
            ))} */}
        {/* {src &&
          extension &&
          (extension[0] !== 'pdf' || extension[0] !== 'ppt') && */}
          {console.log({extension})}
        {src &&
          src.map((item) => {
            return (
              item && (
                <> {
                verifyExtension(item) !== 'image' ? 
                 <video
                  src={item}
                  width="150px"
                  style={{ marginTop: '10px', cursor: 'pointer', marginLeft: '5px' }}
                  onClick={() => {
                    setOpen(true)
                    setImagePreview(item)
                  }}
                  alt="pre"
                /> :
                 <img
                src={item}
                width="150px"
                style={{ marginTop: '10px', cursor: 'pointer', marginLeft: '5px' }}
                onClick={() => {
                  setOpen(true)
                  setImagePreview(item)
                }}
                alt="pre"
              />
          }
                </>
               
              )
            )
          })}
      </Box>

      {imagePreview && <ImageDialog open={open} handleClose={() => setOpen(false)} image={imagePreview} />}
    </Box>
  )
}
